import React from 'react'
import Button from '../ui/Button'
import { FormButtons, FormContent, FormPair} from '../ui/Form';
import {H3} from '../ui/Header';

function SignUp({ updateFormState }) {

  return (
    <FormContent>
      <H3>Account Information</H3>
      <FormPair>
        <label>Username:</label>
        <input
          name='username'
          onChange={e => updateFormState(e)}
          placeholder='username'
        />
      </FormPair>
      <FormPair>
        <label>Password:</label>
        <input
          type='password'
          name='password'
          onChange={e => updateFormState(e)}
          placeholder='password'
        />
      </FormPair>
      <FormPair>
        <label>Email:</label>
        <input
          name='email'
          onChange={e => updateFormState(e)}
          placeholder='email'
        />
      </FormPair>
      <H3>Personal Information (optional, saved for faster checkout)</H3>
      <FormPair>
        <label>First Name:</label>
        <input
          type='text'
          onChange={e => updateFormState(e)}
        />
      </FormPair>
      <FormPair>
        <label>Middle Name:<br/>(Optional)</label>
        <input
          type='text'
          onChange={e => updateFormState(e)}
        />
      </FormPair>
      <FormPair>
        <label>Last Name:</label>
        <input
          type='text'
          onChange={e => updateFormState(e)}
        />
      </FormPair>
      <FormPair color='text'>
        <label>Phone number:<br/><small>Eg : 081 222 2224 </small></label>
        <input
          type="tel"
          onChange={e => updateFormState(e)}
          placeholder="888-888-8888"
          pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
          maxLength="12"
          title="888-888-8888"/>
      </FormPair>
      <FormButtons>
        <Button type='submit'>Sign Up</Button>
      </FormButtons>
    </FormContent>
  )
}

export default SignUp